import React from "react";
import { Card, Kpi, Field, SelectInput } from "@/components/ExcelUI";
import { pct, sum } from "@/lib/excelCalc";

export default function FotoTab({ activeYears, WEEKS, fotoYear, setFotoYear, fotoWeek, setFotoWeek, fotoGroups, setPhotoView, API }) {
  return (
    <>
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900 mb-1">Foto-overzicht</h1>
          <p className="text-sm text-slate-500">Alle storings- en uitvalfoto's, gegroepeerd per week en dag. Ingevoerd door de productie via de telefoon.</p>
        </div>
      </div>
      <Card className="mb-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-end">
          <Field label="Jaar"><SelectInput testid="foto-year" value={fotoYear} onChange={setFotoYear} options={["0", ...activeYears.map(String)]} /></Field>
          <Field label="Week (0 = hele jaar)"><SelectInput testid="foto-week" value={fotoWeek} onChange={setFotoWeek} options={["0", ...WEEKS.map(String)]} /></Field>
          <Kpi label="Regels met foto's" value={fotoGroups.length} />
          <Kpi label="Totaal foto's" value={sum(fotoGroups, (g) => g.photos.length)} />
        </div>
      </Card>
      {fotoGroups.length === 0 ? (
        <Card><div className="text-center text-slate-400 py-10">Geen foto's in deze periode.</div></Card>
      ) : (
        <div className="space-y-4" data-testid="foto-overzicht">
          {fotoGroups.map((g) => (
            <Card key={g.id} className="!p-4">
              <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                <div>
                  <span className="font-semibold text-slate-800">{g.product}</span>
                  <span className="text-sm text-slate-500"> · {g.lijn} · {g.datum} · wk {g.weeknr}</span>
                </div>
                <div className="text-xs text-slate-500">Uitval {pct(g.uitvalPct)}{g.opmerking ? ` · ${g.opmerking}` : ""}</div>
              </div>
              <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
                {g.photos.map((p, i) => {
                  const tok = localStorage.getItem("clazing_token") || "";
                  return <button key={i} data-testid="foto-thumb" onClick={() => setPhotoView(g.photos)} className="block"><img src={`${API}/files/${p}?auth=${tok}`} alt={`foto ${i + 1}`} className="h-24 w-full object-cover rounded-md border border-slate-200 hover:opacity-90" /></button>;
                })}
              </div>
            </Card>
          ))}
        </div>
      )}
    </>
  );
}
